module.exports = __webpack_public_path__ + "img/Layer_5.bb32022d.png";